import script from "./device-status-old.vue?vue&type=script&setup=true&lang=js"
export * from "./device-status-old.vue?vue&type=script&setup=true&lang=js"

import "./device-status-old.vue?vue&type=style&index=0&id=6549fd98&scoped=true&lang=css"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6549fd98"]])

export default __exports__